export const SET_SURVEY_QUESTIONS = 'SET_SURVEY_QUESTIONS'
export function setSurveyQuestions(payload) {
  return {
    type: SET_SURVEY_QUESTIONS,
    payload
  }
}

export const SET_SURVEY_QUESTIONS_ERROR = 'SET_SURVEY_QUESTIONS_ERROR'
export function setSurveyQuestionsError(payload) {
  return {
    type: SET_SURVEY_QUESTIONS_ERROR,
    payload
  }
}

export const SET_SURVEY_ID = 'SET_SURVEY_ID'
export function setSurveyId(payload) {
  return {
    type: SET_SURVEY_ID,
    payload
  }
}

export const SET_SURVEY_SUBMIT_ERROR = 'SET_SURVEY_SUBMIT_ERROR'
export function setSurveySubmitError(payload) {
  return {
    type: SET_SURVEY_SUBMIT_ERROR,
    payload
  }
}

export const SET_SURVEY_COMPLETED = 'SET_SURVEY_COMPLETED'
export function setSurveyCompleted(payload) {
  return {
    type: SET_SURVEY_COMPLETED,
    payload
  }
}

export const CLEAR_SURVEY_STATE = 'CLEAR_SURVEY_STATE'
export function clearSurveyState() {
  return {
    type: CLEAR_SURVEY_STATE
  }
}
